<template>
  <div class="box">
    <div class="laws_detail">
      <!-- <h2>
        {{ informationAll.name }}
      </h2> -->
      <div style="display: flex; margin: 30px 0 0 0">
        <div class="img">
          <span>{{ informationAll.name }}</span>
        </div>
        <div class="message">
          <div class="title">
            <h3 style="margin: 0 0px">{{ informationAll.name }}</h3>
            <div class="collection" v-if="!informationAll.coll">
              <el-tooltip content="收藏" placement="left" effect="light">
                <img
                  @click="collectible(informationAll)"
                  src="../../../../assets/imgs/2.0/_收藏.png"
                  alt=""
                />
              </el-tooltip>
            </div>
            <div class="collection" v-if="informationAll.coll">
              <el-tooltip content="收藏" placement="left" effect="light">
                <img
                  v-if="informationAll.coll == 0"
                  @click="collectible(informationAll)"
                  src="../../../../assets/imgs/2.0/_收藏.png"
                  alt=""
                />
              </el-tooltip>
              <el-popconfirm
                title="确认取消收藏吗？"
                @confirm="cancel(informationAll)"
              >
                <img
                  slot="reference"
                  v-if="informationAll.coll == 1"
                  src="../../../../assets/imgs/2.0/收藏3.png"
                  alt=""
                />
              </el-popconfirm>
            </div>
          </div>

          <div class="mation">
            <p style="width: 100%">
              <span class="tit">统一社会信用代码：</span
              ><span class="con">{{ informationAll.firm_code }}</span>
            </p>
            <p>
              <span class="tit">电话：</span
              ><span class="con">{{ informationAll.tel }}</span>
            </p>
            <p>
              <span class="tit">所属地区：</span
              ><span class="con">{{ city_one }}</span>
            </p>
            <p>
              <span class="tit">成立时间：</span
              ><span class="con">{{ informationAll.year }}年</span>
            </p>
            <p>
              <span class="tit">律师人数：</span
              ><span class="con">{{ informationAll.nums }}</span>
            </p>
            <!-- <p style="width:100%">
              <span class="tit">联系地址：</span
              ><span class="con" style="">{{ informationAll.address }}</span>
            </p> -->
            <div class="brief">
              <span class="tit">联系地址：</span>
              <span v-if="informationAll.address"><span v-if="informationAll.address.length < 60">{{
                informationAll.address
              }}</span
              ><span v-if="informationAll.address.length >= 60 && !ress"
                >{{ informationAll.address.slice(0, 60)
                }}<span class="operate" @click="address">...更多</span></span
              >
              <span v-if="informationAll.address.length >= 60 && ress"
                >{{ informationAll.address
                }}<span class="operate" @click="address">收起</span></span
              ></span>
              
            </div>
            <div class="brief">
              <span class="tit">机构简介：</span>
              <span v-if="informationAll.introduction"><span v-if="informationAll.introduction.length < 60">{{
                informationAll.introduction
              }}</span
              ><span v-if="informationAll.introduction.length >= 60 && !more"
                >{{ informationAll.introduction.slice(0, 60)
                }}<span class="operate" @click="view">...更多</span></span
              >
              <span v-if="informationAll.introduction.length >= 60 && more"
                >{{ informationAll.introduction
                }}<span class="operate" @click="view">收起</span></span
              ></span>
              
            </div>
          </div>
          <!-- <div class="cards">
            <el-card shadow="always">
              <p>律师人数</p>
              <p>{{ informationAll.nums }}</p>
            </el-card>

            <el-card shadow="always">
              <p>统一社会信用代码</p>
              <p>{{ informationAll.firm_code }}</p>
            </el-card>

            <el-card shadow="always">
              <p>成立时间</p>
              <p>{{ informationAll.year }}年</p>
            </el-card>

            <el-card shadow="always">
              <p>所属地区</p>
              <p>{{ city_one }}</p>
            </el-card>

            <el-card shadow="always">
              <p>电话</p>
              <p>{{ informationAll.tel }}</p>
            </el-card>
          </div> -->
        </div>
      </div>
      <!-- <div class="jianjie">
        <div
          style="
            font-size: 18px;
            font-weight: 600;
            min-width: 80px;
            margin: 0 20px 0 0;
          "
        >
          机构简介:
        </div>
        <div style="margin: 0 20px 0 0">{{ informationAll.introduction }}</div>
      </div>
      <div class="jianjie">
        <div
          style="
            font-size: 18px;
            font-weight: 600;
            min-width: 80px;
            margin: 0 20px 0 0;
          "
        >
          联系地址:
        </div>
        <div style="">{{ informationAll.address }}</div>
      </div> -->
      <!-- <div class="introduce">
        <div style="padding: 10px 0">
          <img
            style="width: 400px"
            src="../../../../assets/imgs/哲思首页配图/1.png"
            alt=""
          />
        </div>
        <div class="text">
          <h3>机构简介</h3>
          <p v-if="informationAll.introduction !== ''">
            {{ informationAll.introduction }}
          </p>
          <p v-if="informationAll.introduction == ''">
            君合律师事务所于1989年创立于北京，是中国最早的合伙制律师事务所之一。发展至今，君合已在海内外拥有十三个办公室和一支由超过260位合伙人和顾问、670多位受雇律师和法律翻译组成的逾930人的专业团队，是国际公认的、最优秀的中国大型综合律师事务所之一。
          </p>
          <h5>联系地址</h5>
          <p>{{ informationAll.address }}</p>
        </div>
      </div> -->
      <!-- <div class="lawes">
        <div class="law" v-for="(item, index) in lawList" :key="index">
          <div class="photo">
            <img src="../../../../assets/imgs/哲思首页配图/02.png" alt="" />
          </div>
          <div class="personal">
            <p>姓名：{{ item.name }}</p>
            <p>
              从业时间：<span v-if="item.years > 0">{{ item.years }}年</span
              ><span v-if="item.years == 0">未满一年</span>
            </p>
            <p>执业证号:{{ item.zyzh }}</p>
          </div>
        </div>
      </div> -->
      <div class="law_list">
        <h3>
          律师团队<span>{{ totalLaws }}</span>
        </h3>
        <el-table :data="lawList" stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="name" label="姓名" width="120" align="center">
          </el-table-column>

          <el-table-column prop="lawfirm" label="从业机构" align="center">
          </el-table-column>
          <el-table-column
            prop="_source.TrialPro"
            label="从业时间"
            width="120"
            align="center"
          >
            <template slot-scope="scope"
              ><span v-if="scope.row.years >= 1">{{ scope.row.years }}年</span>
              <span v-else>未满1年</span></template
            >
          </el-table-column>
          <el-table-column prop="zyzh" label="执业证号" align="center">
          </el-table-column>
        </el-table>
      </div>
      <div class="page-bar" v-if="totalLaws > 5">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalLaws > 10000 ? 10000 : totalLaws"
          @current-change="handleCurrentChangeLaws"
          :page-size="10"
        >
        </el-pagination>
      </div>
      <div class="lawsCase" style="margin: 20px 0 10px 0">
        <h3>
          代理案件<span>{{ totalCount }}</span>
        </h3>
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column
            prop="_source.RefereeDate"
            label="发布日期"
            width="120"
            align="center"
          >
          </el-table-column>

          <el-table-column prop="_source.CaseId" label="案号" align="center">
          </el-table-column>
          <el-table-column
            prop="_source.TrialPro"
            label="案件类型"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="_source.Casename"
            label="案件名称"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column prop="_source.TrialPro" label="案件身份">
          </el-table-column> -->
          <el-table-column prop="" label="裁判结果" align="center" >
            <template slot-scope="scope"
              >
              <span v-if="scope.row._source.result"><span v-if="scope.row._source.result.length > 50"
                >{{ scope.row._source.result.substring(0, 51) }}...
                <el-tooltip class="item" effect="light" placement="bottom">
                  <div slot="content" class="resultsDetail">
                    {{ scope.row._source.result }}
                  </div>
                  <span class="results">详情</span>
                </el-tooltip>
              </span></span>
              
              <span v-if="scope.row._source.result"><span v-if="scope.row._source.result.length <= 50">{{
                scope.row._source.result
              }}</span></span>
              
              <!-- <span :class="scope.row._source.result.length > 55 ? 'results' : ''">{{ scope.row._source.result }}</span> -->
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <router-link
                :to="{ path: `/detail/${scope.row._id}` }"
                target="_blank"
                ><el-button type="text" size="small">详情</el-button>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-bar" v-if="totalCount > 5">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalCount > 10000 ? 10000 : totalCount"
            @current-change="handleCurrentChange"
            :page-size="10"
          >
          </el-pagination>
        </div>
      </div>
      <div class="position">
        <h3>位置信息</h3>
        <div class="positioning">
          <!-- <el-input v-model="formName.location" class="from_location" /> -->
          <div>
            <baidu-map
              :center="center"
              :zoom="zoom"
              :scroll-wheel-zoom="true"
              class="dw"
            >
              <bm-view style="width: 100%; height: 100%; flex: 1" />
              <bm-local-search :auto-viewport="true" style="display: none" />
              <bm-marker :position="{ lng: center.lng, lat: center.lat }" />
            </baidu-map>
          </div>
        </div>
      </div>
    </div>
    <ComFooter></ComFooter>
  </div>
</template>

<script>
import store from "@/store";
import ComFooter from "../../../../components/ComFooter.vue";
export default {
  data() {
    return {
      parameter: "", //接收路由参数
      informationAll: "", //律所数据
      lawList: [], //律师数据
      tableData: [],
      caseNumber: 55,
      city_one: "",
      center: {
        lng: 0,
        lat: 0,
      }, // 定位信息
      zoom: 13, // 定位信息
      formName: {
        location: "",
        longitude: "",
        latitude: "",
        address: "",
      },
      totalCount01: 0, //律所律师数量
      totalCount: 0, //律所案例数量
      totalPage: 1,
      totalLaws: 0, //律师数量
      lawsPage: {
        id: "",
        page: 1,
        pagesize: 10,
      },
      more: false,
      ress: false,
    };
  },
  created() {
    this.parameter = this.$route.query;
    this.lawsPage.id = this.$route.query.id;
    this.getInformation();
  },
  methods: {
    // 律所详情
    getInformation() {
      this.$http
        .post("/lawfirminfo", this.parameter)
        .then((res) => {
          console.log(res);
          console.log(res);
          if (res.data.code == 200) {
            this.informationAll = res.data.data.lawfirm;
            // this.lawList = res.data.data.lawer.list;
            this.city_one = this.informationAll.city.name;
            this.center = {
              lng: this.informationAll.jd,
              lat: this.informationAll.wd,
            };
            this.getLaws();
            this.getCase();

            // console.log(this.lawList);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLaws() {
      this.$http
        .post("/lawfirminfo", this.lawsPage)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.lawList = res.data.data.lawer.list;
            this.totalLaws = res.data.data.lawer.value;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleCurrentChangeLaws(val) {
      // console.log(typeof val)
      this.lawsPage.page = val;
      this.getLaws();
    },
    // 律所代理案件
    getCase() {
      let parameter = {
        page: this.totalPage,
        pageSize: 10,
        search: '{"word":"","type":"all","searchtype":"2"}',
        court: "", //法院
        reason: "", //案由
        keyword: "", //关键词
        doctype: "", //文书类型
        trialpro: "", //审判程序
        level: "", //法院级别
        referencelevel: "", //参照级别
        order: JSON.stringify({ field: "RefereeDate", type: "desc" }),
        casename: "", //文书标题
        judge: "", //审判人员、、法官
        lawer: "", //代理律师
        casetype: "", //案件类型
        lawfirm: this.informationAll.name, //代理律所
        clomethod: "", //终审结果
        refereedate: JSON.stringify({ start: "", end: "" }), //审结日期
        caseid: "",
        content: "",
      };
      this.$http
        .post("/search", parameter)
        .then((res) => {
          console.log(res);
          this.tableData = res.data.data.list.hits;
          // if()
          this.totalCount = res.data.data.list.total.value;
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    handleCurrentChange(val) {
      // console.log(typeof val)
      this.totalPage = val;
      this.getCase();
    },
    collectible(it) {
      console.log(it);
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          // user_id: store.getCookie("user_id"),
          docid: it.id,
          // role: store.getCookie("role"),
          doctype: 2,
          docname: it.name,
        };
        this.$http
          .post("/coll", collOne)
          .then((res) => {
            console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getInformation();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    cancel(it) {
      // console.log("a");
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          docid: it.id,
        };
        this.$http
          .post("/delcoll", collOne)
          .then((res) => {
            console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getInformation();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    // 去案件详情页
    handleClick(row) {
      console.log(row);
      this.$router.push({
        path: "/detail",
        params: row._id,
      });
    },
    view() {
      this.more = !this.more;
    },
    address() {
      this.ress = !this.ress;
    },
  },
  components: {
    ComFooter,
  },
};
</script>

<style lang="less" scoped>
.box {
}
.laws_detail {
  background: url("../../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
  background-size: 100% 1000px;
  background-repeat: no-repeat;
  // min-width: 1260px;
  padding: 0 20px;
  min-width: 1280px;
  // max-width: 1280px;
  width: 1280px;
  margin: auto;
  h2 {
    line-height: 100px;
    font-size: 25px;
    font-weight: 700;
    text-align: center;
  }
  
  h3 {
    line-height: 50px;
    font-size: 18px;
    font-weight: 600;
    span {
      color: rgb(83, 171, 223);
      margin: 0 10px;
    }
  }
  .cards {
    //   margin-top: 30px;
    display: flex;
    // justify-content: center;
    .el-card {
      width: 200px;
      margin: 0 10px;
      // background: rgb(184, 184, 184);
      p {
        line-height: 20px;
        // font-size: 16px;
        text-align: center;

        padding: 5px 0px;
      }
      /deep/ .el-card__body {
        padding: 10px;
      }
    }
  }
  .introduce {
    margin: 5% 18%;
    display: flex;
    justify-content: space-between;
    .text {
      width: 400px;
      h3 {
        line-height: 50px;
        font-size: 18px;
        font-weight: 600;
      }
      p {
        line-height: 20px;
        // margin: 10px 0;
        text-indent: 2em;
      }
      h5 {
        margin: 20px 0 0 0;
        line-height: 30px;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  .lawes {
    margin: 30px 100px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .law {
      margin: 10px;
      width: 200px;
      //   .photo{
      //       img{
      //           width: 120px;
      //       }
      //   }
      .personal {
        p {
          line-height: 30px;
        }
      }
    }
  }
  .position {
    margin: 20px 0;
    .positioning {
      height: 300px;
      background: white;
      border-radius: 10px;

      .dw {
        // margin: 10px;
        // margin: 10px 10%;
        width: 100%;
        height: 300px;
        div {
          border-radius: 10px;
        }
      }
    }
  }
}
.page-bar {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}
.resultsDetail {
  width: 300px;
  line-height: 20px;
  font-size: 14px;
}
.el-tooltip {
  /deep/ .el-tooltip__popper {
    background: rgb(235, 235, 235);
    color: #000000;
  }
}

.results {
  color: #409eff;
  margin: 0 0 0 10px;
  cursor: pointer;
}
.img {
  margin: 20px 30px 20px 0px;
  width: 150px;
  height: 120px;
  // background: #dddddd;
  background: #8ca3cd;
  color: #fff;
  border-radius: 5px;
  // line-height: 132px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin: 0 20px;
    line-height: 20px;
    display: inline-block;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
  }
}
.message {
  max-width: 1000px;
}
.jianjie {
  margin: 20px 0;
  display: flex;
  line-height: 30px;
}
.mation {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  background: #ffffff;
  p {
    display: inline-block;
    width: 50%;
    line-height: 30px;
    .tit {
      text-align: right;
      display: inline-block;
      width: 130px;
    }
  }
  .brief {
    line-height: 20px;
    display: flex;
    span {
      display: inline-block;
      max-width: 850px;
    }
    .tit {
      text-align: right;
      display: inline-block;
      width: 130px;
    }
    .operate {
      margin: 0 10px;
      font-weight: 600;
      color: rgb(0, 162, 236);
    }
    .operate:hover {
      color: #88bff7;
      cursor: pointer;
    }
  }
}
.title {
    display: flex;
    justify-content: space-between;
    // margin-bottom: 10px;
    line-height: 28px;
    cursor: pointer;
    // h2 {
    //   font-size: 16px;
    //   font-weight: 600;
    // }
  }
  .collection {
    
  img {
    margin-top: 12px;
    width: 28px;
  }
}
.collection:hover img {
  cursor: pointer;
  // content: url("../../../assets/imgs/2.0/收藏3.png");
}
</style>